module.exports = __webpack_public_path__ + "media/images/landkit/masks/avatar-status-0411443e58727758421dc1bb45d1b19f.svg";